import { Box, Button, Modal, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { professions } from "../asset/js/Professions";
import "./settings-modern.css";

const animatedComponents = makeAnimated();

function ProfessionModal({ open, admin, handleClose, user, addChangedUser, updatePage }) {
  const officialProfessions = Array.from(professions);
  const options = officialProfessions.map((profession) => ({ value: profession, label: profession }));
  const currentProfessions = user.profession
    ? user.profession.split(",").filter((profession) => officialProfessions.includes(profession))
    : [];
  const [selectedOptions, setSelectedOptions] = React.useState(
    currentProfessions.map((profession) => ({ value: profession, label: profession }))
  );

  const handleSubmit = () => {
    const profession = selectedOptions.map((option) => option.value).join(",");
    if (profession === user.profession) {
      handleClose("profession");
      return;
    }

    const request = admin === "yes"
      ? axios.put(
          `${process.env.React_APP_BACKEND_URL}/api/admin/updateuser?id=${user.id}`,
          { profession },
          { headers: { Authorization: `Bearer ${Cookies.get("admintoken")}` } }
        )
      : axios.put(
          `${process.env.React_APP_BACKEND_URL}/api/updateuser?id=${user.id}`,
          { profession },
          { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
        );

    request
      .then(() => {
        if (addChangedUser) addChangedUser();
        if (admin !== "yes") Cookies.set("profession", profession, { expires: 365 });
        if (updatePage) updatePage();
        handleClose("profession");
      })
      .catch((err) => console.log(err));
  };

  return (
    <Modal open={open} onClose={() => handleClose("profession")} aria-labelledby="profession-modal-title">
      <Box className="bidit-settings-modal">
        <Box className="bidit-settings-head">
          <Typography id="profession-modal-title" className="bidit-settings-title">
            עדכון מקצועות
          </Typography>
          <Typography className="bidit-settings-subtitle">
            בחרו רק מתוך המקצועות הפעילים בבידאיט. כך המערכת יכולה להתאים אליכם מכרזים בצורה מדויקת.
          </Typography>
        </Box>

        <Select
          components={animatedComponents}
          isMulti
          name="professions"
          value={selectedOptions}
          options={options}
          onChange={(items) => setSelectedOptions(items || [])}
          className="bidit-settings-select"
          classNamePrefix="select"
          isClearable
          isSearchable
          closeMenuOnSelect={false}
          placeholder="חיפוש ובחירת מקצועות"
          noOptionsMessage={() => "המקצוע לא קיים כרגע ברשימה"}
        />

        <Box className="bidit-settings-note">
          חסר מקצוע ברשימה? אל תוסיפו שם חופשי שלא ניתן להתאים למכרזים. אפשר לפנות אלינו דרך עמוד התמיכה ונבדוק אם כדאי להוסיף אותו למערכת.
        </Box>

        <Button fullWidth onClick={handleSubmit} variant="contained" className="bidit-settings-primary" sx={{ mt: 2.5 }}>
          שמירת מקצועות
        </Button>
      </Box>
    </Modal>
  );
}

export default ProfessionModal;
